class WriteWithAi {
  constructor({ api, config, data }) {
    this.api = api;
    this.config = config;
    WriteWithAi.isShowAi = config.isShowAi;

    this.data = data;
  }

  static get toolbox() {
    if(WriteWithAi.isShowAi){
      return {
        title: 'Write With AI',
        icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="20.001" height="20" rx="3" fill="url(#paint0_linear_32131_635621)"/><path d="M3.00036 14.7053C3.07985 14.6021 3.14875 14.489 3.2399 14.3975C6.09065 11.5431 8.94396 8.69056 11.7965 5.83799C12.0725 5.56199 12.2891 5.56236 12.5666 5.83981C13.1076 6.3805 13.6487 6.9212 14.1894 7.46262C14.4271 7.7007 14.4285 7.93805 14.1919 8.17503C11.3072 11.0601 8.42259 13.9451 5.53574 16.8283C5.46684 16.8968 5.37605 16.9435 5.29511 17H5.07636C4.97026 16.9176 4.85505 16.845 4.76025 16.7513C4.25311 16.2508 3.74924 15.7469 3.24865 15.2397C3.15495 15.145 3.0824 15.0294 3 14.9233C3 14.8504 3 14.7774 3 14.7045L3.00036 14.7053ZM5.17516 15.9062C7.14651 13.9352 9.12151 11.9602 11.0721 10.01C10.7155 9.64799 10.3465 9.27355 9.99216 8.9137C8.02628 10.8796 6.05383 12.852 4.08795 14.8175C4.44853 15.1785 4.81786 15.5482 5.17516 15.9059V15.9062ZM12.1932 6.7338C11.682 7.24459 11.1632 7.76341 10.6572 8.2691C11.0127 8.62457 11.382 8.99391 11.7309 9.34319C12.2421 8.83239 12.7612 8.31394 13.268 7.80789C12.9122 7.45241 12.5429 7.08308 12.1932 6.7338ZM8.4091 5.46939C8.70442 5.76325 8.91807 6.11472 9.1248 6.51249C9.49449 5.70455 10.0684 5.13469 10.8825 4.75952C10.0636 4.38618 9.49449 3.81158 9.11933 3C8.74525 3.81559 8.1754 4.38509 7.36855 4.75661C7.7696 4.96224 8.11597 5.17771 8.4091 5.46939ZM14.2656 3.78096C14.0508 3.99534 13.7821 4.15503 13.5273 4.34608C14.0997 4.60311 14.5208 5.03662 14.8052 5.64366C15.0884 5.02823 15.5132 4.60275 16.0823 4.34571C15.8289 4.15722 15.5624 4.00117 15.3509 3.79007C15.1355 3.57496 14.9743 3.30589 14.8026 3.07802C14.6349 3.30225 14.4777 3.56913 14.2656 3.78096ZM16.114 9.12297C15.9226 9.53861 15.6397 9.81533 15.2339 10.0057C15.6459 10.1982 15.923 10.4811 16.1151 10.884C16.3084 10.4778 16.5887 10.1978 17.0007 10.0038C16.5804 9.81315 16.3058 9.52803 16.114 9.12297Z" fill="white"/><defs><linearGradient id="paint0_linear_32131_635621" x1="20.001" y1="9.78723" x2="-5.42615e-08" y2="9.78723" gradientUnits="userSpaceOnUse"><stop stop-color="#F241CD"/><stop offset="1" stop-color="#4B5DEE"/></linearGradient></defs></svg>'
      };
    }else{
      return null
    }
  }

  save() {
    return {
      value: null
    }
  }

  render() {
    const paragraph = document.createElement('p');
    paragraph.innerHTML = "Write with AI";
    paragraph.dataset.type = "WW_AI";
    if (this.config.openSidebar) {
      this.config.openSidebar();
    }

    return paragraph;
  }

  static get isReadOnlySupported(){
    return true
  }
}

  export default WriteWithAi;